<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
// import { defineProps } from "vue";
import Button from "./Button.vue";
import { ref } from "vue";
import { aboutMe } from "../dataFiles/About";
const aboutMeToggle = ref(false);

const text = "Resume";
</script>
<template>
  <div class="flex flex-col md:flex-row justify-center items-center">
    <div
      class="flex flex-col md:flex-row justify-around items-center"
      v-show="aboutMeToggle == false"
    >
      <!-- about-image -->
      <div
        class="bg-black w-[300px] md:w-[400px] flex justify-center items-center rounded-2xl shadow-inner md:-translate-y-24"
      >
        <img src="../assets/images/about-me-outside.png" alt="imege" />
      </div>

      <!-- about text -->
      <div
        class="flex flex-col justify-center items-center md:items-start w-[90%] md:w-1/2 my-12 md:my-0"
      >
        <div class="flex justify-center items-center my-10">
          <h1 class="text-2xl text-white font-semibold my-2 nav-links">
            About
            <span class="text-yellow-800">me</span>
          </h1>
        </div>
        <p
          class="w-full md:w-5/6 text-white text-lg flex justify-center items-center"
        >
          I have been a graphic designer for 3+ years, and I posses considerable
          proficiency in Adobe Photoshop, Adobe Illustrator, photo and video
          editing, as well as photography. My passion and enthusiasm for design
          enable me to produce distinct and attention-grabbing designs that
          effectively appeal to customers. My work is deceptively simple, yet
          remarkable. I am not one to shy away from difficult challenges;
          rather, I approach them with enthusiasm and a desire to overcome any
          obstacles. Ultimately, I strive to provide my clients with complete
          satisfaction through my work.
        </p>
        <!-- Resume button -->
        <div>
          <a href="../dataFiles/onu_emmanuel_resume.pdf" download>
            <Button :text="text" />
          </a>
        </div>
        <i
          class="text-white animate-pulse cursor-pointer bi bi-arrow-bar-right text-4xl"
          @click="aboutMeToggle = !aboutMeToggle"
        >
        </i>
      </div>
    </div>
    <!-- about me slide-->
    <div
      class="flex flex-col justify-around items-center w-[85%] md:w-[50%] box rounded-3xl"
      v-show="aboutMeToggle"
    >
      <div class="w-[100px] h-[100px] my-10 rounded-full">
        <img
          src="../assets/images/profile-pix.png"
          alt="me"
          class="rounded-full border-4 border-gray-100"
        />
      </div>
      <main class="text-white w-5/6 md:w-5/6" :style="{ margin: '20px auto' }">
        <div
          v-for="item in aboutMe"
          :key="item.name"
          class="flex flex-col md:flex-row justify-start items-center my-4"
        >
          <h1 class="font-semibold text-lg md:text-xl capitalize my-2">
            {{ item.name }}
          </h1>
          <p
            class="mx-10 text-sm md:text-lg w-[90%] md:w-full my-2 flex justify-center items-center md:block"
          >
            {{ item.desc }}
          </p>
        </div>
      </main>
      <i
        class="text-white animate-pulse cursor-pointer my-10 bi bi-arrow-bar-left text-4xl"
        @click="aboutMeToggle = !aboutMeToggle"
      >
      </i>
    </div>
  </div>
</template>

<style>
.gradient {
  background: linear-gradient(
    to bottom,
    #5a2b02 0%,
    /* color stop 1 */ #c9c6c6 50%,
    /* color stop 2 */ #5a2b02 100% /* color stop 3 */
  );
}
</style>
